import React, { createContext } from "react";
import "../styles/App.css";
import StandaloneBar from "./header/StandaloneBar";
import { useGet } from "react-common";
import SlideshowEditor from "./SlideshowEditor";
import { Route, Routes } from "react-router-dom";
import SlideshowPresentation from "./SlideshowPresentation";
import Home from "./Home";
import Presentation from "./Presentation";

export const AppContext = createContext();

const App = () => {

    const [session] = useGet('Session');

    if (!session)
        return null;

    return (
        <div className="App">
            <AppContext.Provider value={session.user}>
                <StandaloneBar/>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/editor" element={<SlideshowEditor/>}/>
                    <Route path="/presentation/:presentationID/presenter" element={<SlideshowPresentation presenterView={true}/>}/>
                    <Route path="/presentation/:presentationID" element={<SlideshowPresentation presenterView={false}/>}/>
                    <Route path="/presentation" element={<Presentation/>}/>
                </Routes>
            </AppContext.Provider>
        </div>
    );
};

export default App;
